<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mirror-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.15 4.322l36.063 36.063a1 1 0 010 1.414L41.8 43.213a1 1 0 01-1.414 0L4.322 7.151a1 1 0 010-1.414l1.415-1.415a1 1 0 011.414 0zM30 37.071l4.855 4.855-3.462 1.48a1 1 0 01-1.393-.92V37.07zM4 11.07l4 4v20.31l6 2.562V21.07l4 4v17.416a1 1 0 01-1.283.959l-.11-.04-12-5.124a1 1 0 01-.6-.801L4 37.361V11.07zm18 18l4 4V41a1 1 0 01-1 1h-2a1 1 0 01-1-1V29.07zm9-24.577a1 1 0 01.38.075l12 4.939a1 1 0 01.62.924V36.93l-4-4V12.44l-6-2.47v16.96l-4-4V5.493a1 1 0 011-1zM25 6a1 1 0 011 1v11.93l-4-4V7a1 1 0 011-1h2zm-8-1.507a1 1 0 01.993.883l.007.117v5.437l-4.91-4.91 3.53-1.452a1 1 0 01.38-.075z"/></svg>
</template>
<script>

export default {
  name: 'IconMirrorOff',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
